// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { Settings } from 'src/app/_interfaces/settings-model';
import { AnnouncementModel } from 'src/app/api/remote-api/.portal.generated/models';
import { SettingsService } from '../../shared/services/settings.service';
import { SystemOverviewService } from './systemOverview.service';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementService {
  constructor(
    private systemOverviewService: SystemOverviewService,
    private settingsService: SettingsService
  ) { }

  activeAnnouncement$ = combineLatest({
    announcement: this.systemOverviewService.announcement.lastSuccessfulData$,
    settings: this.settingsService.settings$,
  }).pipe(map(AnnouncementService.filterActiveAnnouncement));

  hiddenAnnouncement$ = combineLatest({
    announcement: this.systemOverviewService.announcement.lastSuccessfulData$,
    settings: this.settingsService.settings$,
  }).pipe(map(AnnouncementService.filterHiddenAnnouncement));

  static filterHiddenAnnouncement({
    announcement,
    settings,
  }: {
    announcement: AnnouncementModel;
    settings: Settings;
  }): AnnouncementModel | undefined {
    if (announcement) {
      if (settings.lastConfirmedAnnouncementIndex) {
        if (
          (announcement.indexIncrement || 0) <=
          settings.lastConfirmedAnnouncementIndex
        ) {
          return announcement;
        }
      }
    }
  }

  static filterActiveAnnouncement({
    announcement,
    settings,
  }: {
    announcement: AnnouncementModel;
    settings: Settings;
  }): AnnouncementModel | undefined {
    if (announcement) {
      if (settings.lastConfirmedAnnouncementIndex) {
        if (
          (announcement.indexIncrement || 0) <=
          settings.lastConfirmedAnnouncementIndex
        ) {
          return undefined;
        }
      }
      return announcement;
    }
  }

  /**
   * call with undefined to reset the announcement setting
   */
  public closeAnnouncement(index: number | null = null): void {
    this.settingsService.updateSettings({
      lastConfirmedAnnouncementIndex: index
    });
  }
}
